// import InnvoLightLogo from 'assets/innvolight/InnvoLightLogoWhite.png'
import InnvoLightLogo from 'assets/innvolight/InnvoLightLogoWhite-orange.png'
// import InnvoCrossLogo from 'assets/innvolight/InnvoCrossLogoWhite.png'
import InnvoCrossLogo from 'assets/innvolight/InnvoCrossLogoWhite-orange.png'

const InnvoLightData = [
  {
    feature: 'Resolution (μm)',
    value: '≤ 15',
  },
  {
    feature: 'Frame rate (fr/s)',
    value: '200',
  },
  {
    feature: 'Pullback range (mm)',
    value: '40/55/80',
  },
  {
    feature: 'Pullback speed (mm/s)',
    value: '20/40',
  },
  {
    feature: 'Scan range (mm)',
    value: '10',
  },
  {
    feature: 'Hard drive capacity (TB)',
    value: '6',
  },
]

const InnvoCrossData = [
  {
    feature: 'Usable Length',
    value: '1350 mm',
  },
  {
    feature: 'Profile',
    value: '2.58 Fr (0.86 mm)',
  },
  {
    feature: 'Lens position from tip',
    value: '20mm',
  },
  {
    feature: 'Separate Lens Lumen',
    value: 'yes',
  },
]

export default function Specifications() {
  return (
    <div className="relative h-auto bg-center bg-slate-50">
      <div className="relative z-10 max-w-[1440px] w-full mx-auto h-full py-20  px-4  md:px-10 lg:px-16 2xl:px-0">
        <div className="flex flex-col gap-10 w-full">
          <div className="flex flex-col gap-5 items-center w-full">
            <div className="w-full max-w-[180px] gsap-opacity-trans-appear">
              <img
                src={InnvoLightLogo}
                className="object-contain w-full h-full"
                alt=""
              />
              <h4 className="text-2xl font-bold text-center text-orange">
                Specifications
              </h4>
            </div>
            {/* <div className="mx-auto w-full max-w-2xl">
              <div className="overflow-x-auto rounded-3xl transition-shadow duration-300">
                <table className="overflow-hidden w-full rounded-3xl border border-separate border-spacing-0">
                  <tbody className="gsap-stagger-bounce-parent">
                    {InnvoLightData.map((val, ind) => {
                      return (
                        <tr
                          key={ind}
                          className="grid grid-cols-2 gsap-stagger-bounce"
                        >
                          <td className="px-4 py-3 text-center border">
                            {val.feature}
                          </td>
                          <td className="px-4 py-3 text-center border">
                            {val.value}
                          </td>
                        </tr>
                      )
                    })}
                  </tbody>
                </table>
              </div>
            </div> */}
            <div className="overflow-x-auto overflow-y-hidden mx-auto w-full max-w-2xl">
              <div className=" border-2 border-gray-500 rounded-3xl min-w-[500px]">
                <table className="w-full text-left border-collapse">
                  <tbody className="gsap-stagger-bounce-parent">
                    {InnvoLightData.map((item, index) => (
                      <tr
                        key={index}
                        className={`${
                          index !== InnvoLightData.length - 1
                            ? 'border-b border-gray-500'
                            : ''
                        } grid grid-cols-2 gsap-stagger-bounce`}
                      >
                        <td className="px-6 py-4 font-medium whitespace-nowrap border-r border-gray-500">
                          {item.feature}
                        </td>
                        <td className="px-6 py-4 font-medium text-center whitespace-nowrap">
                          {item.value}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div className="flex flex-col gap-5 items-center w-full">
            <div className="w-full max-w-[180px] gsap-opacity-trans-appear">
              <img
                src={InnvoCrossLogo}
                className="object-contain w-full h-full"
                alt=""
              />
              <h4 className="text-2xl font-bold text-center text-orange">
                Specifications
              </h4>
            </div>
            <div className="overflow-x-auto overflow-y-hidden mx-auto w-full max-w-2xl">
              <div className="border-2 border-gray-500 min-w-[500px] rounded-3xl">
                <table className="overflow-hidden w-full text-left border-collapse">
                  <tbody className="gsap-stagger-bounce-parent">
                    {InnvoCrossData.map((item, index) => (
                      <tr
                        key={index}
                        className={`${
                          index !== InnvoCrossData.length - 1
                            ? 'border-b border-gray-500'
                            : ''
                        } grid grid-cols-2 gsap-stagger-bounce`}
                      >
                        <td className="px-6 py-4 font-medium min-w-[140px] border-r border-gray-500 whitespace-nowrap">
                          {item.feature}
                        </td>
                        <td className="px-6 py-4 font-medium min-w-[140px] text-center whitespace-nowrap">
                          {item.value}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
